<template>
  <div class="limitMain">
    <h6>
      <span class="txt">权限详情</span>
      <span class="bg"></span>
    </h6>
    <div class="limitItem">
      <div class="head">商品分享权限</div>
      <ul>
        <li>拥有个人主页探店吃喝玩乐小店功能，支持通过探店吃喝玩乐小店pc端添加关联商品。</li>
        <li>支持你在你的作品中添加第三方链接分享商品。</li>
      </ul>
    </div>
    <div class="limitItem">
      <div class="head">开通小店</div>
      <ul>
        <li>完成小店的入驻流程后，你的探店吃喝玩乐账号将与你的小店账号绑定，同时将为你开通探店吃喝玩乐商品分享权限，你可在你的作品中添加商品。</li>
        <li>适合于需要售卖商品，同时存在分享商品需求的探店吃喝玩乐作者。</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: null
    }
  },
  created(){
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.limitMain {
  width: 100%;
  min-height: 100%;
  position: absolute;
  top: 0;
  background: url('../assets/image/limitBg.png') no-repeat top #FFF8F8;
  background-size: cover;
  padding: 1.84rem 0.426667rem;
  box-sizing: border-box;
  h6{
    font-size: 0.96rem;
    font-weight: 800;
    color: #333333;
    padding-left: 0.426667rem;
    span{
      position: relative;
      &.txt{
        z-index: 1;
      }
      &.bg{
        width: 3.833333rem;
        height: 0.533333rem;
        background: rgba(255, 186, 187, .6);
        display: block;
        top:-.5rem;
        z-index: 0;
      }
    }
  }
  .limitItem{
    background: #fff;
    margin: 0.853333rem 0;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
    .head{
      height: 1.013333rem;
      line-height: 1.013333rem;
      padding: 0 0.426667rem;
      background: #F3474A;
      font-size: 0.426667rem;
      color: #FFFFFF;
    }
    ul{
      padding: 0 0.526667rem 0 .7rem;
      li{
        font-size: 0.4rem;
        font-weight: 500;
        color: #3C3C3C;
        margin: 0.433333rem 0;
        position: relative;
        &::before{
          content: '';
          width: 15px;
          height: 15px;
          background: #F3474A;
          border-radius: 15px;
          display: inline-block;
          position: absolute;
          top: .2rem;
          left: -25px;
        }
      }
    }
  }
}
</style>